var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.525,
    y: 0.525,
    width: 19.95,
    height: 19.95,
    rx: 9.975,
    stroke: "#007AFF",
    strokeWidth: 1.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 8.086V13H8.493V10.977H6.631V13H5.434V8.086H6.631V10.011H8.493V8.086H9.69ZM14.0541 13.84L13.4241 12.993C13.2375 13.0303 13.0555 13.049 12.8781 13.049C12.4161 13.049 11.9915 12.9417 11.6041 12.727C11.2215 12.5123 10.9158 12.2137 10.6871 11.831C10.4631 11.4437 10.3511 11.0097 10.3511 10.529C10.3511 10.0483 10.4631 9.61667 10.6871 9.234C10.9158 8.85133 11.2215 8.55267 11.6041 8.338C11.9915 8.12333 12.4161 8.016 12.8781 8.016C13.3401 8.016 13.7625 8.12333 14.1451 8.338C14.5325 8.55267 14.8358 8.85133 15.0551 9.234C15.2791 9.61667 15.3911 10.0483 15.3911 10.529C15.3911 10.949 15.3048 11.334 15.1321 11.684C14.9641 12.0293 14.7285 12.3163 14.4251 12.545L15.5031 13.84H14.0541ZM11.5761 10.529C11.5761 10.963 11.6928 11.3107 11.9261 11.572C12.1641 11.8287 12.4815 11.957 12.8781 11.957C13.2701 11.957 13.5828 11.8263 13.8161 11.565C14.0541 11.3037 14.1731 10.9583 14.1731 10.529C14.1731 10.095 14.0541 9.74967 13.8161 9.493C13.5828 9.23167 13.2701 9.101 12.8781 9.101C12.4815 9.101 12.1641 9.22933 11.9261 9.486C11.6928 9.74267 11.5761 10.0903 11.5761 10.529Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHq);
export default __webpack_public_path__ + "static/media/HQ.dc0f574db99637e5b8b4311b44879fad.svg";
export { ForwardRef as ReactComponent };